import CHART_TYPES from './charts'

import FINANCIAL_REPORTS from './pages/financial-reports/'
import STORE_REPORTS from './pages/store-reports'
import SITE_REPORTS from './pages/site-reports'
import ADVANCED_REPORTS from './pages/advanced-reports'

const PageConfig = {
  ...FINANCIAL_REPORTS,
  ...STORE_REPORTS,
  ...SITE_REPORTS,
  ...ADVANCED_REPORTS
}

export default PageConfig
export { CHART_TYPES }
